const DeclinedInternal = {
    No: 0,
    Yes: 1,
}
export default DeclinedInternal